/**
 * Spinner sizes — preset diameters in pixels for the three common slots
 * (inline-with-text, inline-with-button, standalone block). Picked to align
 * with the icon sizes of {@link IconButton} so a spinner can swap in for
 * a glyph without throwing the row off-baseline.
 */
export const SPINNER_SIZE_SM = 'sm';
export const SPINNER_SIZE_MD = 'md';
export const SPINNER_SIZE_LG = 'lg';

export type SpinnerSize =
  | typeof SPINNER_SIZE_SM
  | typeof SPINNER_SIZE_MD
  | typeof SPINNER_SIZE_LG;

/**
 * Pixel diameter for each preset size. Stroke width scales with the
 * diameter so the visual weight stays consistent across sizes.
 */
export const SPINNER_SIZE_TOKENS: Record<
  SpinnerSize,
  { diameter: number; stroke: number }
> = {
  [SPINNER_SIZE_SM]: { diameter: 14, stroke: 1.5 },
  [SPINNER_SIZE_MD]: { diameter: 18, stroke: 1.75 },
  [SPINNER_SIZE_LG]: { diameter: 24, stroke: 2 },
};
